import Masonry from 'masonry-layout'
var imagesLoaded = require('imagesloaded');
$(document).ready(function(){
  var grid = document.querySelector('.grid');
  var msnry;

  if ($(".grid").length){

    /*imagesLoaded( grid, function() {
      // init Isotope after all images have loaded
      msnry = new Masonry( grid, {
        itemSelector: '.grid-item',
        gutter: 15,
        fitWidth: true
      });
    });*/
    // init Masonry

    msnry = new Masonry( grid, {
      itemSelector: '.grid-item',
      gutter: 15,
      fitWidth: true
    });

    imagesLoaded( grid ).on( 'progress', function() {
      // layout Masonry after each image loads
      msnry.layout();
    }); 
  }
      
});

